<template>
    <div>
        <app-header>
            <template slot="title">Profil</template>
            <template slot="right">Speichen</template>
        </app-header>
        <div class="container table-wrapper-scroll-y">
            <div class="row" id="row-image">
                <img src="./../assets/images/profil-img.png">
            </div>
            <div class="row" id="nexts">
                <div class="nexts-item btn-base">
                    <div class="col-1">
                        <img src="./../assets/images/account-upgrade-icon.svg">
                    </div>
                    <div class="font-normal col-10 ">Account Upgrade</div>
                    <div class="col-1">
                        <img src="./../assets/images/next.svg" alt="">
                    </div>
                </div>
                <div class="nexts-item  btn-base">
                    <div class="col-1">
                        <img src="./../assets/images/logout-icon.svg">
                    </div>
                    <div class="font-normal col-10">Ausloggen</div>
                    <div class="col-1">
                        <img src="./../assets/images/next.svg" alt="">
                    </div>
                </div>
            </div>
            <div class="row" id="info">
                <div class="font-btn-small">Profil Informaationen</div>
            </div>
            <div class="row" id="form">
                <form class="form-profil">
                    <tr>
                        <td class="form-padding">
                            <div class="font-btn-small">Vorname</div>
                            <input type="text" class="font-input font-normal" value="Max">
                        </td>
                        <td class="form-padding"><img src="./../assets/images/set-icon.svg"></td>
                    </tr>
                    <tr>
                        <td class="form-padding">
                            <div class="font-btn-small">Name</div>
                            <input type="text" class="font-input font-normal" value="Mustermann">
                        </td>
                        <td class="form-padding"><img src="./../assets/images/set-icon.svg"></td>
                    </tr>
                    <tr>
                        <td class="form-padding">
                            <div class="font-btn-small">Email</div>
                            <input type="email" class="font-input font-normal"
                                   value="mail@mustermann.com">
                        </td>
                        <td class="form-padding"><img src="./../assets/images/set-icon.svg"></td>
                    </tr>
                    <tr>
                        <td class="form-padding">
                            <div class="font-btn-small">Passwort</div>
                            <input type="password" class="font-input font-normal"
                                   value="almafa">
                        </td>
                        <td class="form-padding"><img src="./../assets/images/set-icon.svg"></td>
                    </tr>
                </form>
            </div>
        </div>
        <div id="nav">
            <app-nav></app-nav>
        </div>
    </div>
</template>

<script>
  import Header from './../components/Header'
  import Nav from './../components/Nav'

  export default {
    components: {
      appHeader: Header,
      appNav: Nav
    }
  }
</script>

<style lang="scss" scoped>
    @import './../styles/app';

    .table-wrapper-scroll-y {
        max-height: 550px;
    }

    .row {
        padding: 0 20px;
    }

    #row-image {
        background-color: $color-bg-grey;
        width: 100%;
        img {
            margin: auto;
        }
    }

    #nexts {
        display: block;
        .nexts-item {
            padding: 15px 0;
            border-bottom: 1px solid $color-list-border;
            * {
                display: inline-block;
            }
            .font-normal {
                padding-left: 5px;
                color: $color-secondary;
                font-weight: bold;
            }
            .col-1 {
                line-height: 15px;
                img {
                    vertical-align: sub;
                }
            }

        }
    }

    .font-btn-small {
        font-size: 11px;
        color: $font-light;
        padding: 0 !important;
    }

    #info {
        background-color: $color-bg-grey;
        padding-top: 30px;
        padding-bottom: 10px;
    }

    td {
        padding-left: 2px !important;
    }
</style>
